import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "page-section bg-primary text-white mb-0",
  id: "about"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<h2 class=\"page-section-heading text-center text-uppercase text-white\">O mně</h2><div class=\"divider-custom divider-light\"><div class=\"divider-custom-line\"></div><div class=\"divider-custom-icon\"><i class=\"fas fa-code\"></i></div><div class=\"divider-custom-line\"></div></div>", 2)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-4 ml-auto" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "lead" }, [
    /*#__PURE__*/_createTextVNode(" Jsem web developer se zaměřením na back-end,"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" avšak ovládám i front-end. ")
  ])
], -1)
const _hoisted_7 = { class: "col-lg-4 mr-auto" }
const _hoisted_8 = { class: "lead" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("p", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.languages, (language) => {
              return (_openBlock(), _createElementBlock("span", {
                key: language.value
              }, _toDisplayString(language.value) + ", ", 1))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}